import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/services/dialog.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { finalize, map, Observable, Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import Swal from 'sweetalert2';
import { helper } from 'src/environments/helper';
import { PermissionsService } from 'src/app/services/permissions.service';
import { AddEntityComponent } from './add-entity/add-entity.component';
import { EditEntityComponent } from './edit-entity/edit-entity.component';
import { PersonsEntityService } from './persons-entity.service';

@Component({
    selector: 'app-persons-entity-types',
    templateUrl: './persons-entity-types.component.html',
    styleUrls: ['./persons-entity-types.component.scss'],
})
export class PersonsEntityTypesComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    showCard = false;
    activeValue: string = '-1';
    publicValue: string = '-1';

    isFilterLoading = false;

    defaultParameter: { name: string; id: number } = {
        name: 'Toate',
        id: -1,
    };

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink = this.requestService.listDTUrl;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    resetForm() {
        this.activeValue = '-1';
        this.publicValue = '-1';

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private requestService: PersonsEntityService,
        public permissionsService: PermissionsService
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,
            pageLength: 25,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.active = this.activeValue;
                dataTablesParameters.public_view = this.publicValue;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;

                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Nume',
                    data: 'name',
                },
                {
                    title: 'Observații',
                    data: 'observatii',
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    render: (row: any) => {
                        return `
                        <div class="d-flex align-center justify-content-left">
                        <button class="action-btn edit ms-1" title="Editare">
                            <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
                        </button>
                        <button class="action-btn delete ms-1" title="Ștergere">
                            <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
                        </button>
                        <button type="button" class="action-btn update_status_active ms-1 ` +
                            (row.active == 1 ? 'action-success' : 'action-danger') +
                            `" title="Schimbare status activ">
                                <img class="btn-img" src="` +
                            (row.active == 1
                                ? '/assets/icons/check-white.svg'
                                : '/assets/icons/close-white.svg') +
                            `" alt="update_status_active"/>
                        </button>
                        <button type="button" class="action-btn update_status_public ms-1 ` +
                            (row.public_view == 1
                                ? 'action-success'
                                : 'action-danger') +
                            `" title="Schimbare status public">
                            <img class="btn-img" src="` +
                            (row.public_view == 1
                                ? '/assets/icons/public_white.svg'
                                : '/assets/icons/public_not_white.svg') +
                            `" alt="update_status_public"/>
                        </button>
                    </div>
            `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;
                const updateStatusActiveIcon = lastTd?.querySelector(
                    '.update_status_active'
                ) as HTMLElement;
                const updateStatusPublicIcon = lastTd?.querySelector(
                    '.update_status_public'
                ) as HTMLElement;

                if (editIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'indoc-module.settings.entities.update'
                        )
                    ) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'indoc-module.settings.entities.delete'
                        )
                    ) {
                        deleteIcon.style.display = 'none';
                    }
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.deleteEntry(id);
                    });
                }

                if (updateStatusActiveIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'indoc-module.settings.entities.update-status'
                        )
                    ) {
                        updateStatusActiveIcon.style.display = 'none';
                    }
                    updateStatusActiveIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.changeStatusActive(id);
                    });
                }

                if (updateStatusPublicIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'indoc-module.settings.entities.update-status-public'
                        )
                    ) {
                        updateStatusPublicIcon.style.display = 'none';
                    }
                    updateStatusPublicIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.changeStatusPublic(id);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
        this.showCard = false;
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddEntityComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare adăugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditEntityComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    deleteEntry(id: number) {
        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: helper.swalTextConfig.generalMessages.delete,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.requestService.deleteEntry(id).subscribe({
                    next: () => {
                        this.rerenderDT();
                        Swal.fire({
                            title: this.helper.swalTextConfig.headers.deleted,
                            text: 'Înregistrare ștearsă cu succes.',
                            icon: 'success',
                            confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
                        });
                    },
                    error: (err: any) => {
                        Swal.fire({
                            title: helper.dialogConfig.headers.errorAtentie,
                            text: err.error.errors.message[0],
                            icon: 'error',
                            confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        })
                    }
                });
            }
        });
    }

    changeStatusActive(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să actualizați statusul înregistrării selectate!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusActiveAction(id);
            }
        });
    }

    changeStatusActiveAction(id: number) {
        this.isLoading = true;
        this.requestService.changeStatusActive(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err: any) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusActiveAction(id);
                    }
                });
            }
        );
    }

    changeStatusPublic(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să actualizați statusul înregistrării selectate!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusPublicAction(id);
            }
        });
    }

    changeStatusPublicAction(id: number) {
        this.isLoading = true;
        this.requestService.changeStatusPublic(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusPublicAction(id);
                    }
                });
            }
        );
    }
}

